import React from "react";
import { Link } from "react-router-dom";
import { MerchCard } from "@/components/site/MerchCard";
import { Reveal, RevealGroup, RevealItem } from "@/components/site/Reveal";

export const MerchTeaser = ({ merch = [] }) => {
  if (merch.length === 0) return null;
  return (
    <section className="section-pad" data-testid="merch-teaser-section">
      <div className="mx-auto max-w-[1360px] px-5 sm:px-8">
        <Reveal className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="font-caps text-gold" style={{ fontSize: ".72rem" }}>Products by HNS Records</p>
            <h2 className="font-display foil-text mt-3" style={{ fontSize: "var(--t-h2)", lineHeight: 1.05 }}>Order Yours Today</h2>
          </div>
          <Link to="/merch" className="btn-ghost" data-testid="view-all-merch">View all merch</Link>
        </Reveal>
        <RevealGroup className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 mt-12" stagger={0.05}>
          {merch.map((p) => <RevealItem key={p.id}><MerchCard product={p} /></RevealItem>)}
        </RevealGroup>
      </div>
    </section>
  );
};
